import axiosInstance from './axios';

export interface SiteLanguage {
  code: string;
  name: string;
  nativeName: string;
  logoUrl: string | null;
  isDefault: boolean;
  sortOrder: number;
}

export interface SiteLanguagesResponseData {
  defaultLanguage: string;
  languages: SiteLanguage[];
}

export interface SiteLanguagesResponse {
  data: SiteLanguagesResponseData;
  error: any;
  message: string;
  status: number;
}

export const siteService = {
  getSiteConfig: async () => {
    const response = await axiosInstance.get('/client/site');
    return response.data;
  },
  getLanguages: async (): Promise<SiteLanguagesResponse> => {
    const response = await axiosInstance.get('/client/site/languages');
    return response.data;
  },
};
